import React, { useCallback } from "react";
import { usersPageGlobalVariableDelete } from "../reducers/users-page-global-variable-actions";
import { usersPageCloseModal } from "../reducers/users-page-actions";
import { useToggle } from "react-use";
import { Confirmar } from "../../../../components";
import { useDispatch } from "react-redux";

const STR = {
  title: "Excluir Variável Global",
  subtitle: "Deseja realmente excluir a variável global ?",
};

function GlobalVariableDelete({ id }) {
  const [wait, setWait] = useToggle();
  const dispatch = useDispatch();
  const onConfirm = useCallback(() => {
    dispatch(usersPageGlobalVariableDelete(id, setWait));
  }, [dispatch, setWait, id]);
  //
  const onCancel = useCallback(() => {
    dispatch(usersPageCloseModal());
  }, [dispatch]);

  return (
    <Confirmar
      titulo={STR.title}
      subtitulo={STR.subtitle}
      fnCancelar={onCancel}
      fnConfirmar={onConfirm}
      aguardar={wait}
    />
  );
}

export default GlobalVariableDelete;
